<script>
  import { defineComponent } from '@vue/composition-api'

  export default defineComponent({
    name: 'OfferSpecificityGroup',
    data () {
      return {
        hasSlots: false,
        hasAccessibility: false
      }
    },
    methods: {
      computeSlots () {
        const componentSlots = this.$slots.default && this.$slots.default
          .filter(component => {
            /**
             * Remove any element that's not a component (unmounted comp, text, comments).
             */
            const { componentOptions } = component
            if (!componentOptions || !componentOptions.tag) return false

            /**
             * Excludes components that have no content. Eg. accessibility component with a
             * root v-if.
             */
            return true
          })

        this.hasSlots = !!componentSlots && componentSlots
          .filter(component => component?.componentOptions?.tag !== 'offer-accessibility')
          .length > 0

        // @ts-ignore
        this.hasAccessibility = !!componentSlots && !!componentSlots[0] && componentSlots[0].componentOptions?.tag === 'offer-accessibility' && !!componentSlots[0].componentInstance && !!componentSlots[0].componentInstance.hasAccessibilityIssue
      }
    },
    mounted () {
      this.computeSlots()
    },
    updated () {
      this.computeSlots()
    },
    render (createElement) {
      return createElement('div', {
        class: {
          'offer-specificity-group--arrow': this.hasSlots && !this.hasAccessibility,
          'tw-mb-8': this.hasSlots || this.hasAccessibility,
          'offer-specificity-group tw-relative tw-flex tw-flex-col tw-mt-3': true
        }
      }, [
        this.$slots.default
      ])
    }
  })
</script>

<style lang="scss">.offer-specificity-group--arrow::after {
  --tw-border-opacity: 1;
  border-color: rgba(216, 216, 216, var(--tw-border-opacity));
  position: absolute;
  content: '';
  width: 1rem;
  height: 1rem;
  top: -0.5rem;
  left: 2rem;
  background: white;
  border-width: 1px 0 0 1px;
  border-style: solid;
  transform: rotate(45deg);
}
.offer-specificity-group .offer-accessibility:not(:first-child)::before {
  display: none;
}
.offer-specificity-group > div:not(:last-child) {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-bottom: none;
}
.offer-specificity-group > div:not(:first-child) {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}</style>
